module.exports = __webpack_public_path__ + "img/svg_error.9af2c822.svg";